import React, { FC, memo } from 'react'
import { NewsFeedArticleProps, SeoInfoProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import WrappedNewsTickerEntry from '../WrappedNewsTickerEntry'
import { publishDateInTimeOrDate } from '@/helpers/dateHelper'
import nofollowExternal from '@/utils/url/nofollowExternal'
type Props = {
    componentData: NewsFeedArticleProps & SeoInfoProps
}

const NewsFeedArticle: FC<Props> = ({ componentData }) => {
    const { title, imageUrl, publishedAt, tags, url, description } = componentData
    return (
        <NonFlexingContainer
            display="flex"
            testID="news-feed-article"
            marginBottom="spacing-6"
            marginX={['spacing-6', 'spacing-6', 'spacing-9', 'spacing-none']}
        >
            <WrappedNewsTickerEntry
                headline={title}
                imageUrl={imageUrl}
                alt={description}
                publishedAt={publishedAt ? publishDateInTimeOrDate(publishedAt) : ''}
                href={url}
                discipline={tags?.[0]?.title}
                webRel={nofollowExternal}
            />
        </NonFlexingContainer>
    )
}

export default memo(NewsFeedArticle)
